/* Native Shopify discounts; keep them in sync when the cart changes. */
(() => {
  if (window.KarmaPillarsDiscounts) return;
  const root = window.Shopify?.routes?.root || '/';
  const main = new Set([54151407796570]);
  const legacyBundle = 54890482794842;
  const standard = new Set([53963745821018, 53524129415514, 52845118259546, 54142212702554]);
  const senine = 53858046116186;
  const ownCode = /^PILONI45-(?:[1-4]|SENINE|GANDURI)$/i;
  let queue = Promise.resolve();
  let lastCart;
  let syncing = false;
  function codesFor(cart) {
    const unrelated = (cart.discount_codes || []).map(item => item.code).filter(code => !ownCode.test(code));
    const hasSet = cart.items.some(item => main.has(Number(item.variant_id)) && item.quantity > 0);
    if (hasSet) {
      const count = Math.min(4, cart.items.reduce((sum, item) => sum + (standard.has(Number(item.variant_id)) ? item.quantity : 0), 0));
      if (count) unrelated.push('PILONI45-' + count);
      if (cart.items.some(item => Number(item.variant_id) === senine && item.quantity > 0)) unrelated.push('PILONI45-GANDURI');
    }
    return [...new Set(unrelated)];
  }
  async function separateLegacyBundle(cart) {
    const legacyItems = cart.items.filter(item => Number(item.variant_id) === legacyBundle && item.quantity > 0);
    if (!legacyItems.length) return {cart, migrated: false};
    const quantity = legacyItems.reduce((sum, item) => sum + item.quantity, 0);
    const updates = Object.fromEntries(legacyItems.map(item => [item.key, 0]));
    for (const variant of [54151407796570, senine]) {
      const existing = cart.items.find(item => Number(item.variant_id) === variant);
      updates[existing?.key || String(variant)] = (existing?.quantity || 0) + quantity;
    }
    const response = await fetch(root + 'cart/update.js', {
      method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({updates})
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'Nu am putut separa produsele. Reîncearcă din coș.');
    return {cart: result, migrated: true};
  }
  async function sync() {
    const response = await fetch(root + 'cart.js', {headers: {'Accept': 'application/json'}});
    if (!response.ok) throw new Error('Nu am putut verifica oferta. Reîncearcă din coș.');
    const separated = await separateLegacyBundle(await response.json());
    const cart = separated.cart;
    const codes = codesFor(cart);
    const current = (cart.discount_codes || []).map(item => item.code.toUpperCase()).sort().join(',');
    if (current === codes.map(code => code.toUpperCase()).sort().join(',')) {
      lastCart = cart;
      return {cart, changed: separated.migrated};
    }
    const update = await fetch(root + 'cart/update.js', {
      method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({discount: codes.join(',')})
    });
    const result = await update.json();
    if (!update.ok || result.status) throw new Error(result.description || 'Nu am putut aplica oferta. Reîncearcă din coș.');
    lastCart = result;
    return {cart: result, changed: true};
  }
  function ensure() {
    const task = queue.catch(() => {}).then(sync);
    queue = task;
    return task;
  }
  function refresh(result) {
    if (!result.changed) return;
    window.essentialCartApi?.refreshCart?.();
    document.querySelector('m-cart-drawer')?.onCartDrawerUpdate();
    if (window.MinimogTheme?.pubSubEvents?.cartUpdate) {
      window.MinimogEvents?.emit(window.MinimogTheme.pubSubEvents.cartUpdate, {...result.cart, source: 'four-pillars-discounts'});
    }
  }
  function checkAfterCartChange(cart) {
    if (syncing) return;
    if (cart?.source === 'four-pillars-discounts' || cart?.source === 'four-pillars-offer') return;
    const relevant = (cart?.items || lastCart?.items || []).some(item => (main.has(Number(item.variant_id)) || Number(item.variant_id) === legacyBundle || Number(item.variant_id) === senine)) ||
      (cart?.discount_codes || lastCart?.discount_codes || []).some(item => ownCode.test(item.code));
    if (!relevant) return;
    syncing = true;
    ensure().then(refresh).catch(() => {}).finally(() => { syncing = false; });
  }
  window.KarmaPillarsDiscounts = {ensure, codesFor};
  document.addEventListener('essential-cart:update', event => checkAfterCartChange(event.detail));
  document.addEventListener('DOMContentLoaded', () => {
    if (window.MinimogEvents?.subscribe && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.cartUpdate, checkAfterCartChange);
    }
    const configured = document.body.dataset.ksPillarsCart === 'true' || document.querySelector('four-pillars-offer');
    if (configured) {
      syncing = true;
      ensure().then(refresh).catch(() => {}).finally(() => { syncing = false; });
    }
  });
  document.addEventListener('submit', event => {
    if (event.submitter?.name !== 'checkout' || !syncing) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const form = event.target;
    const button = event.submitter;
    ensure().then(result => {
      refresh(result);
      syncing = false;
      if (button.isConnected) form.requestSubmit(button);
    }).catch(() => { syncing = false; });
  }, true);
})();
